// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignLeftOutlinedSvg
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
export default /*#__PURE__*/React.forwardRef(AlignLeftOutlined);